import React, { createContext, useContext } from 'react';
import { createPortal } from 'react-dom';

// Lets a wizard step render content (e.g. its table pagination) into the parent
// wizard footer instead of below the scrolling content area, freeing vertical space
// for the table. The provider passes the footer slot element; when it's not present
// (value is null) the slot renders nothing.
export const WizardFooterSlotContext = createContext<HTMLElement | null>(null);

const WizardFooterSlot: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const target = useContext(WizardFooterSlotContext);
    if (!target) return null;
    return createPortal(children, target);
};

export default WizardFooterSlot;
